// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"c3b57e8f","496":"38b60b33","774":"a4ce6c16"}[chunkId] + ".chunk.js";
};